import { useEffect, useState } from "react";
import { SortedResultsList, useQuestionizerStore } from "../types/state.ts";
import {
  FDWAntragsteller,
  FDWResultEntry,
} from "../../../restfd2/fdw_result.ts";
import Checkbox from "./checkbox.tsx";
import LoadingIndicator from "./loading-indicator.tsx";
import { QuestionizerResultOverlay } from "./questionizer-result-overlay.tsx";
import { QuestionizerResultSummary } from "./questionizer-result-summary.tsx";
import { QuestionizerResultByGewerk } from "./questionizer-result-by-gewerk.tsx";

export default function QuestionizerResult(props: { id: number }) {
  const result = useQuestionizerStore((state) => state.result);
  const session_id = useQuestionizerStore((state) => state.session_id);
  const gemeinde_id = useQuestionizerStore((state) => state.gemeinde_id);
  const gewerk = useQuestionizerStore((state) => state.gewerk);
  const gebaeude = useQuestionizerStore((state) => state.gebaeude);
  const typ = useQuestionizerStore((state) => state.typ);
  const baujahr = useQuestionizerStore((state) => state.baujahr);
  const wohngebaeude = useQuestionizerStore((state) => state.wohngebaeude);
  const gewerbegebaude = useQuestionizerStore((state) => state.gewerbegebaeude);
  const gemeinnuetzig = useQuestionizerStore((state) => state.gemeinnuetzig);
  const requestResult = useQuestionizerStore((state) => state.requestResult);
  const antragsteller = useQuestionizerStore((state) => state.antragsteller);
  const antragsteller_detail = useQuestionizerStore(
    (state) => state.antragsteller_detail
  );

  const darlehenList = useQuestionizerStore(
    (state) => state.darlehenList
  );
  const zuschuesseList = useQuestionizerStore(
    (state) => state.zuschuesseList
  );


  useEffect(() => {
    requestResult();
  }, [
    session_id,
    gebaeude,
    typ,
    baujahr,
    wohngebaeude,
    gewerbegebaude,
    gemeinnuetzig,
    gemeinde_id,
    gewerk,
    antragsteller_detail,
    antragsteller,
  ]);

  if (session_id == undefined || result == undefined) {
    return (
      <div className={"col-span-12 input-" + props.id}>
        <LoadingIndicator />
      </div>
    );
  }


  if(!darlehenList || !zuschuesseList){
    return (
        <div className={"flex flex-col col-span-12 input-" + props.id}>
          <QuestionizerResultSummary />
          <QuestionizerResultByGewerk/>
        </div>
    );
  }

  return (
    <div className={"flex flex-col col-span-12 input-" + props.id}>
      <QuestionizerResultSummary />
      <QuestionizerResultOverlay />
    </div>
  );
}